
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cms/text-viewer-preview",
      function () {
        return require("private-next-pages/cms/text-viewer-preview/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cms/text-viewer-preview"])
      });
    }
  